const tabs = require('./tabs');
const fieldPassword = require('./forms/field-password');
const fieldTextarea = require('./forms/field-textarea');
const fieldDate = require('./forms/field-date');

module.exports = {
  init() {
    tabs.initAll();
    fieldPassword.initAll();
    fieldTextarea.initAll();
    fieldDate.initAll();
  },
};
